import React from 'react';
import { Icon } from '../icon/Icon';
import './Button.scss';

interface ButtonProps {
  block?: boolean;
  children?: string | number | JSX.Element;
  destructive?: boolean;
  disabled?: boolean;
  icon?: boolean | string;
  iconOnly?: boolean | string;
  number?: boolean | string;
  role?: 'button' | 'submit' | 'reset';
  small?: boolean;
  type?: 'primary' | 'secondary' | 'inverse' | 'passive';

  tabIndex?: number;
  onClick?: (e: React.SyntheticEvent<HTMLButtonElement>) => void;
  onKeyPress?: (e: React.KeyboardEvent<HTMLButtonElement>) => void;
}

export const Button: React.FC<ButtonProps> = ({
  block = '',
  children = null,
  destructive = '',
  disabled = '',
  icon = '',
  iconOnly = '',
  number = '',
  role = 'button',
  small = '',
  type = 'primary',
  tabIndex,
  onClick,
  onKeyPress
}) => {
  let withIcon;

  if (icon && !children) {
    icon;
  }

  if (iconOnly) {
    icon = iconOnly;
    iconOnly = 'icon-only';
  }

  if (type === 'inverse') {
    type = 'inverse';
  }

  if (icon && children) {
    withIcon = 'withIcon';
  } else {
    withIcon = '';
  }

  return (
    <button
      className={`ads-button 
        ${small ? 'small' : ''} 
        ${type} 
        ${destructive ? 'destructive' : ''} 
        ${disabled ? 'disabled' : ''} 
        ${iconOnly} 
        ${number ? 'round' : ''} 
        ${withIcon} 
        ${block ? 'block' : ''}
      `}
      onClick={onClick}
      onKeyPress={onKeyPress}
      tabIndex={tabIndex}
      data-testid="ads-button"
      role={role}
      aria-label={iconOnly ? `${icon} button` : 'icon button'}
      aria-disabled={disabled ? true : false}
    >
      {icon && type === 'secondary' && <Icon name={icon} />}

      {type === 'inverse' && <Icon name={icon} />}

      {icon && type !== 'passive' && type !== 'secondary' && (
        <Icon color="ads-color-inverse" name={icon} />
      )}

      {icon && disabled && type === 'secondary' && (
        <Icon color="ads-color-disabled" name={icon} />
      )}

      {icon && destructive && type === 'secondary' && (
        <Icon color="ads-color-danger" name={icon} />
      )}

      {icon && disabled && type === 'inverse' && (
        <Icon color="ads-color-disabled" name={icon} />
      )}

      {icon && destructive && type === 'inverse' && (
        <Icon color="ads-color-danger" name={icon} />
      )}

      {icon && type === 'passive' && (
        <span>
          <Icon name={icon} />
        </span>
      )}

      {icon && destructive && type === 'passive' && (
        <Icon color="ads-color-danger" name={icon} />
      )}

      {icon && disabled && type === 'passive' && (
        <Icon color="ads-color-disabled" name={icon} />
      )}

      {children}
      <span className="ads-button__border"></span>
    </button>
  );
};
